import { routerReducer, RouterState } from 'react-router-redux';
import { combineReducers } from 'redux';
import models, { ModelState } from './state/models';
import timeTravel, { TimeTravelState } from './state/time-travel';
import ui, { UiState } from './state/ui';

export * from './loaders';
export * from './state/ui';
export * from './state/models';
export * from './state/time-travel';

export interface State {
  models: ModelState;
  routing: RouterState;
  timeTravel: TimeTravelState;
  ui: UiState;
}

export default combineReducers<State>({
  models,
  routing: routerReducer,
  timeTravel,
  ui,
});



// WEBPACK FOOTER //
// ./app/gamma/src/modules/index.ts